export { DocumentErrorView as DocumentError } from './document-error.view'
export type { IDocumentError } from './document-error.types'
